goog.provide("shadow.js.shim.module$date_fns$locale$pt_BR$default");
shadow.js.shim.module$date_fns$locale$pt_BR$default = esm_import$date_fns$locale$pt_BR.default;
